/*
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2021-01-05 13:48:41
 * @LastEditTime: 2021-01-06 18:28:30
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";
import configData from "./config";
Vue.prototype.Images = configData.Images;
Vue.prototype.Constants = configData.Constants;

import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import { isWeixin, parseQuery } from "@utils";
import vueLazyLoad from "vue-lazyload";
import wxShare from './libs/wxShare';
import mixin from '@/mixins/mixin'
Vue.mixin(mixin)

import VConsole from 'vconsole';
// const isDebug = true;
// 本地开发调试注入vConsole
// if (isDebug) {
//     new VConsole();
// }
Vue.use(vueLazyLoad, {

    preload: 1.3, //加载高度比。
    loading: require("@assets/images/noPictrue.png"), //加载时的过渡图片
    error: require("@assets/images/err.png"), //加载失败的图片
    attempt: 1 //每次加载的张数。
});
Vue.use(animate);

Vue.config.productionTip = false;

Vue.config.devtools = process.env.NODE_ENV !== "production";

Vue.prototype.$validator = function(rule) {

    return new schema(rule);
};
Vue.prototype.$wxShare = wxShare;

Vue.prototype.$scroll = $scroll;

Vue.prototype.$dialog = dialog;

const CACHE_KEY = "clear_0.0.1";
if (!localStorage.getItem(CACHE_KEY)) {
    cookie.clearAll();
    localStorage.setItem(CACHE_KEY, 1);
}
let cookieName = "VCONSOLE";
let query = parseQuery();
let urlSpread = query["spread"];
let vconsole = query[cookieName.toLowerCase()];
let md5Crmeb = "b14d1e9baeced9bb7525ab19ee35f2d2"; //CRMEB MD5 加密开启vconsole模式
let md5UnCrmeb = "3dca2162c4e101b7656793a1af20295c"; //UN_CREMB MD5 加密关闭vconsole模式
if (urlSpread !== undefined) {
    var spread = localStorage.getItem("spread");
    urlSpread = parseInt(urlSpread);
    if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
        localStorage.setItem("spread", urlSpread || 0);
    } else if (spread === 0 || typeof spread !== "number") {
        localStorage.setItem("spread", urlSpread || 0);
    }
}
const _isWechat = isWeixin();
if (vconsole !== undefined) {
    if (vconsole === md5UnCrmeb && localStorage.getItem(cookieName))
        localStorage.removeItem(cookieName);
} else vconsole = localStorage.getItem(cookieName);
if (vconsole !== undefined && vconsole === md5Crmeb) {
    localStorage.setItem(cookieName, md5Crmeb, 3600);
    const module = () =>
        import("vconsole");
    module().then(Module => {
        new Module.default();
    });
}
if (_isWechat) {
    // 如果当前路径是授权回调页面，不在这里处理授权，让 Auth.vue 组件去处理
    // 避免重复处理授权 code
    const currentPath = window.location.pathname;
    const isAuthPage = currentPath.includes('/auth/');
    
    console.log('【应用启动】微信环境检测:', {
        isWechat: true,
        currentPath: currentPath,
        isAuthPage: isAuthPage,
        willAutoAuth: !isAuthPage
    });
    
    if (!isAuthPage) {
        const module = () =>
            import ("@libs/wechat");
        module().then(Module => {
            Module.default().then(() => Module.oAuth());
        });
    } else {
        console.log('【应用启动】当前是授权页面，跳过自动授权，由 Auth.vue 处理');
    }
}
const $vm = new Vue({
    router,
    store,
    render: h => h(App)
});
setTimeout(() => {
    $vm.$mount("#app");
}, 300);